module.exports = __webpack_public_path__ + "img/img-carousel-2.2450a96f.jpeg";